<div class="sticky-top fixedtop" id="step{{ indexPage }}" *ngIf="getIsCheckValid('_STEP_ID_SepSep_idAnnonceur')">
    <app-form-errors [stepid]="'_STEP_ID_SepSep_idAnnonceur'" >
    </app-form-errors>
  </div>

<div *ngIf="getForm('FORM_AD')">
    <app-form-input
    [parentForm]="form"
    [value]="facturation.email"
    [label]="facturationMessage.Email"
    [type]="'text'" [rule]="''"
    [name]="getUid()+'_SepAtt_mail'">
    </app-form-input>


    <app-form-input
    [parentForm]="form"
    [value]="facturation.intitule"
    [label]="facturationMessage.Intitule"
    [type]="'text'" [rule]="''"
    [name]="getUid()+'_SepAtt_intitule'">
    </app-form-input>

    <app-form-input
    [parentForm]="form"
    [value]="facturation.libelle.denomination"
    [label]="facturationMessage.Denomination"
    [type]="'text'" [rule]="''"
    [name]="getUid()+'_SepAtt_denomination'">
    </app-form-input>

    <app-form-input
    [parentForm]="form"
    [value]="facturation.libelle.siret"
    [label]="facturationMessage.SIRET"
    [type]="'text'" [rule]="''"
    [name]="getUid()+'_SepAtt_siret'">
    </app-form-input>

    <app-form-input
    [parentForm]="form"
    [value]="facturation.noServiceExecutant"
    [label]="facturationMessage.Nserviceexecutant"
    [type]="'text'" [rule]="''"
    [name]="getUid()+'_SepAtt_serviceexec'">
    </app-form-input>

    <app-form-input
    [parentForm]="form"
    [value]="facturation.numBonCommande"
    [label]="facturationMessage.Nengagementjuridique"
    [type]="'text'" [rule]="''"
    [name]="getUid()+'_SepAtt_engagementjuridique'">
    </app-form-input>

    <app-form-input
    [parentForm]="form"
    [value]="facturation.libelle.adr1"
    [label]="facturationMessage.Serviceoudestinataire"
    [type]="'text'"
    [rule]="'required|maxSize_38'"
    [name]="getUid()+'_SepAtt_servicedestinataire'">
    </app-form-input>

    <app-form-input
    [parentForm]="form"
    [value]="facturation.libelle.adr2"
    [label]="facturationMessage.Immeublebatiment"
    [type]="'text'"
    [rule]="'required|maxSize_38'"
    [name]="getUid()+'_SepAtt_immeublebatiment'">
    </app-form-input>

    <app-form-input
    [parentForm]="form"
    [value]="facturation.libelle.adr3"
    [label]="facturationMessage.Numerolibellevoie"
    [type]="'text'" [rule]="''"
    [name]="getUid()+'_SepAtt_numerolibellevoie'">
    </app-form-input>

    <app-form-input
    [parentForm]="form"
    [value]="facturation.libelle.adr4"
    [label]="facturationMessage.Complementadresseboitepostale"
    [type]="'text'"
    [rule]="'required|maxSize_38'"
    [name]="getUid()+'_SepAtt_compladresseboitepostale'">
    </app-form-input>

    <app-form-input
    [parentForm]="form"
    [value]="facturation.libelle.cp"
    [label]="facturationMessage.Codepostal"
    [type]="'text'" [rule]="''"
    [name]="getUid()+'_SepAtt_codepostal'">
    </app-form-input>

    <app-form-input
    [parentForm]="form"
    [value]="facturation.libelle.pays"
    [label]="facturationMessage.Pays"
    [type]="'text'" [rule]="''"
    [name]="getUid()+'_SepAtt_pays'">
    </app-form-input>

    <app-form-input
    [parentForm]="form"
    [value]="facturation.libelle.tvaIntracommunautaire"
    [label]="facturationMessage.tvaIntracommunautaire"
    [type]="'text'" [rule]="''"
    [name]="getUid()+'_SepAtt_tvaIntracommunautaire'">
    </app-form-input>
</div>

<ng-container *ngIf="getIsSHALorPS()">
    <app-form-input
    [parentForm]="form"
    [value]="facturation.telecopieurannonceur"
    [label]="facturationMessage.Telecopieurannonceur"
    [type]="'text'"
	[rule]="'minSize_10|maxSize_15|pattern_39'"
	[errorMessage]="{'pattern' : 'ctr_973'}"
    [name]="getUid()+'_SepAtt_telecopieurannonceur'">
    </app-form-input>
</ng-container>

<ng-container *ngIf="getIsBOAMPorJOUE()">
    <app-form-input
    [parentForm]="form"
    [value]="annonceur?.login"
    [label]="facturationMessage.IdentifiantannonceurBoampWeb"
    [type]="'text'" [rule]="'required'"
    [name]="getUid()+'_SepAtt_idannonceurboampweb'">
    </app-form-input>

    <app-form-input
    [parentForm]="form"
    [value]="annonceur?.mail"
    [label]="facturationMessage.MailBoampWeb"
    [type]="'text'"
	[rule]="'required|maxSize_200|pattern_1'"
    [errorMessage]="{'required' : 'ctr_104', 'pattern' : 'ctr_117'}"
    [name]="getUid()+'_SepAtt_mailcontactboampweb'">
    </app-form-input>
</ng-container>
